import { useMemo } from 'react'
import { isEmpty, isNonNullish } from 'remeda'
import { getMediaSources } from '@velasca/utils/get-media-sources'
import { MaxWidthContainer } from '../MaxWidthContainer/MaxWidthContainer'
import { ParagraphCompositionWithCta } from '../ParagraphCompositionWithCta/ParagraphCompositionWithCta'
import {
  Background,
  Description,
  Frame,
  Image,
  ImageWrapper,
} from './AboutUsBlock.styles'
import type { AboutUsBlockProps } from './AboutUsBlock.types'

export const AboutUsBlock = ({
  mobileImage,
  desktopImage,
  upperTitle,
  title,
  paragraph,
  cta,
}: AboutUsBlockProps): JSX.Element | null => {
  const mediaSources = useMemo(
    () =>
      mobileImage && desktopImage && getMediaSources(mobileImage, desktopImage),
    [mobileImage, desktopImage],
  )
  const fallbackImage = mediaSources ? mediaSources[0] : null

  if (
    !mobileImage &&
    !desktopImage &&
    !upperTitle &&
    !title &&
    !paragraph &&
    isEmpty(cta)
  ) {
    return null
  }

  return (
    <Background>
      <MaxWidthContainer>
        <Frame>
          <ImageWrapper>
            {isNonNullish(fallbackImage) && !isEmpty(fallbackImage) && (
              <Image
                lazyload
                lqip
                mediaSources={mediaSources ?? undefined}
                alt={fallbackImage.alt}
                sources={fallbackImage.sources}
                imgSrc={fallbackImage.imgSrc}
              />
            )}
          </ImageWrapper>
          <Description>
            <ParagraphCompositionWithCta
              upperTitle={upperTitle}
              title={title}
              description={paragraph}
              cta={cta}
            />
          </Description>
        </Frame>
      </MaxWidthContainer>
    </Background>
  )
}
